// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProjectService model hasMany relations 1`] = `
Array [
  "Project",
]
`;
